import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Settings from 'modules/surveys/components/Participants/Table/Body/BodyLayout/Settings'
import { AccessGroupTableContext } from 'modules/surveys/components/Participants/Table/context'
import EmployeeLabel from 'modules/surveys/components/Participants/common/EmployeeLabel'
import Location from 'modules/surveys/components/Participants/common/Location'
import { SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS } from 'modules/surveys/lib/constants'
import type { Participant } from 'modules/surveys/lib/participant'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'

interface Props {
  participants: Participant[]
}

export default function BodyLayout({ participants }: Props) {
  const loading = React.useContext(AccessGroupTableContext)
  const { form } = useSurveyShowContext()
  const isAnonymous = form?.isAnonymous
  const hasEnoughUsers = participants.length > SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS

  return (
    <Table.Body>
      {loading && <Table.Loading colSpan={3} />}
      {!loading && (
        <>
          {participants.length === 0 && (
            <Table.Blank colSpan={5} text={i18n.t('surveys.index.table.body.no_participants')} />
          )}
          {participants.map((participant) => (
            <Table.Row key={participant.id}>
              <Table.Cell>
                <EmployeeLabel participant={participant} />
              </Table.Cell>
              <Table.Cell>
                <Location locationName={participant.locationName} />
              </Table.Cell>
              <Table.Cell>
                <Settings
                  participantId={participant.id}
                  canHaveSettings={isAnonymous ? hasEnoughUsers : true}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </>
      )}
    </Table.Body>
  )
}
